
import React, { useState, useEffect, useRef } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { UrlsUtils } from '../../utils/UrlsUtils';
import { useFormik } from 'formik';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 720,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 2,
  textAlign: 'center'
};

export default function IndexHeader({ onUpdate, index, widget }) {

  const imgBkRef = useRef();
  const dataDefault = {
    aspect_ratio: '',
    margin_top_desk: '',
    margin_top_mobile: '',
    width_desk: '',
    width_mobile: '',
    image_bk_url: '',
    text: '',
    external_link: '',
  };
  const isInModification = widget[0]?.data && (Object.keys(widget[0]?.data)?.length > 0);
  const allAspectRatio = [
    '1:1',
    '4:3',
    '16:9',
    '21:9',
    '32:9',
  ];
  const [aspectRatio, setAspectRatio] = useState('');

  //Mui Modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  //const handleClose = () => setOpenModal(false);

  useEffect(() => {
    handleOpen();
    if (isInModification) {
      setAspectRatio(widget[0]?.data?.aspect_ratio);
    }
    else{
      setFormikAspectRatio(allAspectRatio[0]);
    }
    //console.log('IndexHeader in modifica: ', isInModification)
  }, [isInModification, widget, setAspectRatio]);


  //Formik
  const formik = useFormik({
    //initialValues: widget ? widget : dataDefault,
    initialValues: isInModification ? widget[0].data : dataDefault,
    enableReinitialize: true,
    onSubmit: values => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  //Gestione chiusura del modal
  function handleClose(event, reason) {
    //console.log(event, reason);
    switch (reason) {
      case 'backdropClick':
        return;
      case 'escapeKeyDown':
        return;
      default:
        setOpenModal(false);
    }
  }

  function imgError(image) {
    image.onError = "";
    image.src = "/img/logo-startupitalia-rocket.png";
    return true;
  }

  //Menu Aspect Ratio
  const [anchorElAspect, setAnchorElAspect] = useState(null);
  const mopenAspect = Boolean(anchorElAspect);
  const handleAspectClick = (event) => {
    setAnchorElAspect(event.currentTarget);
  };
  function handleAspectClose() {
    setAnchorElAspect(null);
  }

  function setFormikAspectRatio(e) {
    //console.log('aspect_ratio: ', e)
    setAspectRatio(e);
    formik.setFieldValue('aspect_ratio', e);
  }

  /* useEffect(() => {
      console.log(formik)
  }, [formik.values]); */

  return (
    <>
      <Modal
        aria-labelledby="ch-modal-title"
        aria-describedby="ch-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      //disableEscapeKeyDown={true} 
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography id="ch-modal-title" variant="h6" component="h2"
              style={{ marginBottom: "20px" }}>
              {isInModification ? 'Index Header' : 'New Index Header'}
            </Typography>

            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 px-3">
                <span className="fw-bold">&nbsp;Aspect ratio:<br></br></span>
                <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                  onClick={handleAspectClick} style={{ minWidth: "160px", backgroundColor: "#0a58ca", color: "white" }} >
                  {aspectRatio}
                </button>
                <Menu
                  id="aspect_ratio"
                  anchorEl={anchorElAspect}
                  open={mopenAspect}
                  onClose={handleAspectClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  {allAspectRatio.map((e, i) => {
                    return <MenuItem key={i} onClick={() => {
                      handleAspectClose(); setFormikAspectRatio(e);
                    }}>{e}</MenuItem>
                  })}
                </Menu>
              </div>
            </div>

            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 px-3">
                <span className="fw-bold">&nbsp;Margin Top Desk:</span>
                <input type="number" max="100" id="margin_top_desk" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.margin_top_desk}
                />
              </div>
            </div>
            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 px-3">
                <span className="fw-bold">&nbsp;Margin Top Mobile:</span>
                <input type="number" max="100" id="margin_top_mobile" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.margin_top_mobile}
                />
              </div>
            </div>

            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 px-3">
                <span className="fw-bold">&nbsp;Width Desk %:</span>
                <input type="number" max="100" id="width_desk" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.width_desk}
                />
              </div>
            </div>
            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 px-3">
                <span className="fw-bold">&nbsp;Width Mobile %:</span>
                <input type="number" max="100" id="width_mobile" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.width_mobile}
                />
              </div>
            </div>

            <div className="row" style={{ minHeight: "106px", display: "flex", textAlign: "left" }}>
              <div className="col-9 mt-3">
                <span className="fw-bold">&nbsp;Image Background URL:</span>
                <input type="text" id="image_bk_url" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange} placeholder="Se vuoto utilizza default"
                  value={formik.values?.image_bk_url}
                />
                <small>
                  default: <i>https://cdn.startupitalia.eu/wp-content/uploads/2023/03/15190044/logo_startupitalia%402x.png</i>
                </small>
              </div>
              <div className="col-3 text-center align-self-center" >
                <a type="button" href={UrlsUtils.recognizingUrl(formik.values?.image_bk_url) ? formik.values?.image_bk_url : null}
                  className="my-tooltip" title="Visualizza immagine" target="_blank" rel="noopener noreferrer">
                  <img src={formik.values?.image_bk_url && formik.values?.image_bk_url} ref={imgBkRef}
                    className="img-thumbnail mt-3" alt='Thumbnail url' onError={() => imgError(imgBkRef.current)}
                    style={{ maxHeight: "5rem", padding: "0px", border: "0px", boxShadow: "0px 0px 5px 0px #6c757d", backgroundColor: "whitesmoke" }}></img>
                </a>
              </div>
            </div>

            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 p-3">
                <span className="fw-bold">&nbsp;Subtitle:</span>

                <input type="text" id="text" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.text}
                />
              </div>
            </div>

            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 px-3">
                <span className="fw-bold">&nbsp;External link:</span>

                <input type="text" id="external_link" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.external_link}
                />
              </div>
            </div>
          
            <div className='justify-content-center p-3'>
              Compila i campi dell'intestazione
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                  onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                  Chiudi
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-success"
                  style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                  onClick={() => { onUpdate(formik.values, index); handleClose(); }}>
                  Conferma
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}